export default __webpack_public_path__ + "static/avatar-9fe881e119bb74e4744fed616b3abbaf.png";